import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { Http } from '@angular/http';
import { AddBandsService } from '../../_services/brand/add-bands.service';
import { PaginationInstance } from '../../../../node_modules/ngx-pagination/dist/ngx-pagination.module';

import * as $ from 'jquery';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [AddBandsService]
})

export class BrandsComponent implements OnInit {
  cookies: Object;
  serviceproviders: string = '';
  serviceprovider: any;
  getallbrands: any;
  filterBrands: any;

  public filterText: string;
  public filterPlaceholder: string;
  public enableFilter: boolean;

  config: any;
  dynamicCurrentPage: number = 1;

  isDesc: boolean = false;
  column: string = 'serviceproviders';
  direction: number;
  itemsPerPage:number = 10;
  constructor(
    // private route: ActivatedRoute,
    private router: Router,
    private AddBandsService: AddBandsService
  ) {
    this.enableFilter = true;
    this.filterText = "";
    this.filterPlaceholder = "Filter..";
    this.cookies = Cookie.getAll();
    if (this.cookies['TokenKey'] == undefined) {
      this.router.navigate(['']);
    }



    if (this.cookies['brandedit'] == 1) {
      this.itemsPerPage = parseInt(this.cookies['itemPerPage']);
      this.filterBrands  = this.cookies['filterkeyUpbrand'];
      this.filterText = this.cookies['filterkeyUpbrand'];
      this.dynamicCurrentPage = parseInt(this.cookies['brandCurrentPage']);
      this.serviceproviders = this.cookies['changeService'];
      this.isDesc = false;
      if(this.cookies['filterCookieDir'] == -1){
        this.isDesc = true;
      }
      this.sort(this.cookies['filterCookieProp']);
      Cookie.set('brandedit', '0');
      Cookie.set('filterkeyUpbrand', '');
      Cookie.set('changeService', '');
      Cookie.set('filterCookieProp', '');
      Cookie.set('filterCookieDir', '');
      Cookie.set('itemPerPage', '');
    }
    
    this.config = {
      id: 'advanced',
      itemsPerPage: this.itemsPerPage,
      currentPage: this.dynamicCurrentPage
    };


    this.AddBandsService.getServiceProviderType().subscribe(
      res => {
        // console.log(res);
        this.serviceprovider = res;
      }
    );

    this.AddBandsService.getallbrands().subscribe(
      res => {
        //  console.log(res);
        this.getallbrands = res;
      }
    );

  }
  ngOnInit() {
  }

  filterKeyUpBrand(event:any){
    Cookie.set('filterkeyUpbrand', event.target.value);
  }

  itemPerPage(event:any){
    Cookie.set('itemPerPage', event.target.value);
  }



  brandEdit(brandId) {
    const d = $('#brandfiltertextId').val().toString();
    const f = $('#brandfilterservice').val().toString();
    const i = $('#itemPerPage').val().toString();
    Cookie.set('filterkeyUpbrand', d);
    Cookie.set('itemPerPage', i);
    Cookie.set('changeService', f);
    this.router.navigate(['brands/edit', brandId]);
  }

  sort(property) {

      this.isDesc = !this.isDesc; // change the direction
      if(this.isDesc){
        this.isDesc = this.isDesc; // change the direction
      }
      
      this.column = property;
      this.direction = this.isDesc ? 1 : -1;
  };


  public filterSearch: string = '';
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;


  public labels: any = {
    previousLabel: 'Previous',
    nextLabel: 'Next',
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: `You're on page`
  };

  private popped = [];



  onPageChange(number: any) {
    this.config.currentPage = number;
    // var pageid = $(".current").text().replace("page ", "");
    // if (this.cookies['locationEdit'] == '1') {
    //   var d = this.cookies['locationCurrentPage'];
    //   $('.ngx-pagination li').each(function (i, li) {
    //     if (d == $.trim($(li).text().replace("page ", ""))) {
    //       alert($(li).text().replace("page ", ""));
    //     }

    //   });
    // }
    Cookie.set('brandCurrentPage', number);
  }

  hideme: any = {};

  deleteBrand(brands) {
    this.AddBandsService.deleteBrands(brands.id).subscribe(
      res => {

      }
    );
         $("#status_" + brands.id).text('Deleted');
        this.hideme[brands.id] = true;
  }


}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/brands/brands.component.ts